var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19069_1758",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19069_1758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39997 7.99987L5.79997 5.39987C5.67775 5.27765 5.61664 5.12209 5.61664 4.9332C5.61664 4.74431 5.67775 4.58876 5.79997 4.46654C5.92219 4.34431 6.07775 4.2832 6.26664 4.2832C6.45553 4.2832 6.61108 4.34431 6.7333 4.46654L9.79997 7.5332C9.86664 7.59987 9.91386 7.67209 9.94164 7.74987C9.96942 7.82765 9.9833 7.91098 9.9833 7.99987C9.9833 8.08876 9.96942 8.17209 9.94164 8.24987C9.91386 8.32765 9.86664 8.39987 9.79997 8.46654L6.7333 11.5332C6.61108 11.6554 6.45553 11.7165 6.26664 11.7165C6.07775 11.7165 5.92219 11.6554 5.79997 11.5332C5.67775 11.411 5.61664 11.2554 5.61664 11.0665C5.61664 10.8776 5.67775 10.7221 5.79997 10.5999L8.39997 7.99987Z",
    fill: "#323335"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.afaa549f.svg";
export { ForwardRef as ReactComponent };